var map = {
	"./import/113": [
		9402,
		3,
		[
			402
		]
	],
	"./import/113.json": [
		9402,
		3,
		[
			402
		]
	],
	"./import/HOP20260523": [
		2476,
		3,
		[
			476
		]
	],
	"./import/HOP20260523.json": [
		2476,
		3,
		[
			476
		]
	],
	"./import/LABOUR_MPS": [
		9333,
		3,
		[
			333
		]
	],
	"./import/LABOUR_MPS.csv": [
		5294,
		1,
		[
			294
		]
	],
	"./import/LABOUR_MPS.json": [
		9333,
		3,
		[
			333
		]
	],
	"./import/ScotParliament": [
		6973,
		3,
		[
			973
		]
	],
	"./import/ScotParliament.json": [
		6973,
		3,
		[
			973
		]
	],
	"./import/UKParliaments": [
		993,
		3,
		[
			993
		]
	],
	"./import/UKParliaments.json": [
		993,
		3,
		[
			993
		]
	],
	"./import/first50mps": [
		4632,
		3,
		[
			632
		]
	],
	"./import/first50mps.json": [
		4632,
		3,
		[
			632
		]
	],
	"./import/mpsandlords": [
		4824,
		3,
		[
			824
		]
	],
	"./import/mpsandlords.json": [
		4824,
		3,
		[
			824
		]
	],
	"./import/patten": [
		2103,
		3,
		[
			103
		]
	],
	"./import/patten.json": [
		2103,
		3,
		[
			103
		]
	],
	"./import/person": [
		4334,
		3,
		[
			334
		]
	],
	"./import/person.json": [
		4334,
		3,
		[
			334
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[2][0]).then(() => (__webpack_require__.t(id, ids[1] | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 8221;
module.exports = webpackAsyncContext;